<template>
  <div class="w-[384px] m-4 ml-0 bg-white p-6 border border-gray-200 rounded-lg shadow-xs overflow-y-auto">
    <div
      class="mb-6"
      v-if="$slots.header"
    >
      <slot name="header" />
    </div>
    <slot name="content" />
  </div>
</template>
